import React from "react";
import ReactDOM from "react-dom";
import App from "./AppWithStore";

// css
import "./css/normalize.css";
import "antd/dist/antd.css";
import "./css/index.css";

ReactDOM.render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js